import PropTypes from 'prop-types'

import { SHIPPING_STATUS_CODES } from '../../../common/constants'

import StatusCodeQuickFiltersView from './View'

const StatusCodeQuickFilters = ({
  filters,
  disabledFilterByStatusCode,
  disabledGenerateManifest,
  updateFilters,
  onGenerateManifestClick,
}) => {
  const isOptionChecked = statusCode =>
    filters.statusCode?.includes(statusCode) ?? false

  const updateSingleOption = prevSelectedStatusOption => {
    const statusCodeFilter = filters.statusCode ?? []

    const activeStatuses = prevSelectedStatusOption.checked
      ? statusCodeFilter.filter(
          statusCode => statusCode !== prevSelectedStatusOption.id,
        )
      : [...statusCodeFilter, prevSelectedStatusOption.id]

    updateFilters(activeStatuses)
  }

  return (
    <StatusCodeQuickFiltersView
      isOptionChecked={isOptionChecked}
      disabledFilterByStatusCode={disabledFilterByStatusCode}
      disabledGenerateManifest={disabledGenerateManifest}
      updateOption={updateSingleOption}
      onGenerateManifestClick={onGenerateManifestClick}
    />
  )
}
StatusCodeQuickFilters.propTypes = {
  filters: PropTypes.shape({
    statusCode: PropTypes.arrayOf(
      PropTypes.oneOf(Object.values(SHIPPING_STATUS_CODES)),
    ),
  }).isRequired,
  disabledFilterByStatusCode: PropTypes.bool,
  disabledGenerateManifest: PropTypes.bool,
  updateFilters: PropTypes.func.isRequired,
  onGenerateManifestClick: PropTypes.func.isRequired,
}

export default StatusCodeQuickFilters
